module.exports = __webpack_public_path__ + "img/blank-green-icon.cbf62e4d.svg";